import { DEFAULT_STATE } from '../constants'

export const initialPolygonState = {
  polygonRanges: DEFAULT_STATE.polygonRanges,
  minPolygon: DEFAULT_STATE.minPolygon,
  maxPolygon: DEFAULT_STATE.maxPolygon,
}
